// sessionStorage key
export const TOKEN_KEY = "tokenKey";
// 活动类型枚举
export const leadsTypeEnum = {
  0: "现金红包",
  1: "询价",
  2: "红包优惠券",
  3: "店内活动",
  4: "经销商到店礼",
  5: "大转盘奖品活动",
  6: "外采松鼠平台",
  7: "直采PMO平台",
  8: "红包雨",
  9: "拼图",
  11: "GO平台",
  12: "直播",
  13: "影响力IM"
}
// ics首页待办是否分享key
export const ICS_SHARED = 'icsShared'
